import { render, staticRenderFns } from "./IntegrationList.vue?vue&type=template&id=0c2e82ee&scoped=true&"
import script from "./IntegrationList.vue?vue&type=script&lang=js&"
export * from "./IntegrationList.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationList.vue?vue&type=style&index=0&id=0c2e82ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2e82ee",
  null
  
)

export default component.exports